import axios from "../../../../api/axios";

import { CountryWithBranches } from "../types/entityLocationsByCountry.types";

export const getEntityLocationsByCountry = async (entityId: string): Promise<CountryWithBranches[]> => {
  const response = await axios.get(`/football-entity-branches/group-by-country?footballEntityId=${entityId}`);
  return response.data.data;
};
